import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, " آخرین پیام هایی که از طریق وب‌سرویس شما ارسال شده ", -1)
const _hoisted_3 = {
  class: "card-toolbar",
  "data-kt-buttons": "true"
}
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat" }, null, -1)
const _hoisted_6 = ["element-loading-text"]
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-1" }
const _hoisted_9 = { class: "py-1" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "ms-5 d-flex flex-column" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_13 = { class: "symbol symbol-20px symbol-circle" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  src: "/media/avatars/blank.png",
  alt: ""
}
const _hoisted_16 = {
  class: "fs-8 fw-bolder text-gray-900 text-hover-primary me-2 text-end",
  dir: "ltr"
}
const _hoisted_17 = { class: "d-flex align-items-center mb-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "d-flex align-items-center mx-5" }
const _hoisted_22 = { class: "text-muted fs-7" }
const _hoisted_23 = { class: "badge badge-light" }
const _hoisted_24 = {
  key: 1,
  class: "text-muted fs-8 fw-lighter mx-2"
}
const _hoisted_25 = {
  key: 2,
  class: "text-muted fs-8 fw-lighter mx-2"
}
const _hoisted_26 = {
  key: 4,
  class: "text-danger badge badge-light-danger fs-9"
}
const _hoisted_27 = { class: "" }
const _hoisted_28 = {
  key: 0,
  style: {"white-space":"pre-wrap"},
  class: "text-gray-600 lh-lg fs-7"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi- fs-2 me-1" }, null, -1)
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  class: "d-flex justify-content-center flex-stack flex-wrap",
  dir: "ltr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Status = _resolveComponent("Status")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.widgetClasses])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => {
                  _ctx.filter = 'latest_sends';
                  _ctx.getItems();
                }),
                class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary px-4 me-1"
              }, _toDisplayString(_ctx.translate("latest_sends")), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => {
                  _ctx.filter = 'newest';
                  _ctx.getItems();
                }),
                class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary px-4 me-1 active"
              }, _toDisplayString(_ctx.translate("newest")), 1),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
                  _ctx.filter = 'Status';
                  _ctx.getItems();
                }),
                class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary px-4"
              }, _toDisplayString(_ctx.translate("Status")), 1),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getItems())),
                class: "btn btn-sm btn-primary btn-active btn-active-light-primary px-4"
              }, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.translate("Update")), 1)
              ])
            ])
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "card-body card-scroll py-3",
        "element-loading-text": _ctx.translate('loading')
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            (item.avatar)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: item.avatar,
                                  alt: ""
                                }, null, 8, _hoisted_14))
                              : (_openBlock(), _createElementBlock("img", _hoisted_15)),
                            _createElementVNode("a", _hoisted_16, _toDisplayString(item.to), 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            (item.document_path !== null)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => {_ctx.screen_shot = true; _ctx.screen_path = item.document_path}
                                }, _hoisted_20, 8, _hoisted_18))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("span", _hoisted_22, " (" + _toDisplayString(item.bot.name) + ") ", 1),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(item?.platform), 1)
                            ]),
                            (item.sent_at_object)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.sent_at_object?.jalali), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.sent_at), 1)),
                            (item.status !== 'error')
                              ? (_openBlock(), _createBlock(_component_Status, {
                                  key: 3,
                                  status: item.status
                                }, null, 8, ["status"]))
                              : _createCommentVNode("", true),
                            (item.error)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.translate(item.error)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.messages, (message, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "border bg-light rounded p-3 mb-2"
                            }, [
                              (message.message)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(message.message.replaceAll( '<br>' , '\n').replaceAll( '<br/>' , '\n')), 1))
                                : (message.attachment_file)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: message.attachment_file,
                                      class: "d-inline-block nav-link btn btn-sm btn-color-gray-600 btn-active-color-primary btn-active-light-primary fw-bold px-4 me-1 collapsible active",
                                      download: ""
                                    }, [
                                      _hoisted_30,
                                      _createTextVNode(_toDisplayString(_ctx.translate("download")), 1)
                                    ], 8, _hoisted_29))
                                  : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        (_ctx.list && _ctx.list.length === 0)
          ? (_openBlock(), _createBlock(_component_Notice, {
              key: 0,
              classes: "rounded-3",
              color: "primary",
              title: _ctx.translate('pay attention'),
              body: _ctx.translate('There is no data')
            }, null, 8, ["title", "body"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.screen_shot,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.screen_shot) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.screen_path,
              style: {"width":"100%"}
            }, null, 8, _hoisted_31)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 8, _hoisted_6)), [
        [_directive_loading, _ctx.loading]
      ]),
      _createElementVNode("div", _hoisted_32, [
        (_ctx.pagination && _ctx.pagination.total_pages > 1)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              pagerCount: 4,
              background: "",
              layout: "prev, pager, next",
              class: "mt-4 mb-4",
              total: _ctx.pagination.total,
              currentPage: _ctx.pagination.current_page,
              "page-size": _ctx.pagination.per_page,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["total", "currentPage", "page-size", "onSizeChange", "onCurrentChange"]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}